import { Injectable, Injector } from "@angular/core";
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpResponse
} from "@angular/common/http";
import { Observable } from "rxjs";
import { get } from "lodash";
import { tap } from "rxjs/operators";

@Injectable()
export class ErrorkickoutInterceptor implements HttpInterceptor {
  constructor() {}
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      tap((response: HttpEvent<Response>) => {
        if (response instanceof HttpResponse) {
          const action = get(response, "config.data.info.action");
          if (
            action !== "Ping" &&
            (response.headers.get("X-Bolt-ErrorOrKickout") ||
              response.headers.get("X-Bolt-SessionExpired"))
          ) {
            let url = "";
            const correlationId = response.headers.get("X-Bolt-CorrelationId");
            const sessionId = response.headers.get("X-Bolt-SessionId");
            let flowType = "";

            if ((<any>window).dataLayer) {
              (<any>window).dataLayer.forEach(item => {
                if (item.channelType) {
                  flowType = item.channelType;
                }
              });
            }

            if (response.headers.get("X-Bolt-ErrorOrKickout")) {
              url = `assets/images/error-pixel.gif?flowType=${flowType}&correlationId=${correlationId}&sessionId=${sessionId}`;
            } else {
              url = `assets/images/session-expired-pixel.gif?flowType=${flowType}&correlationId=${correlationId}&sessionId=${sessionId}`;
            }

            let img = document.createElement("img");
            img.style.position = "absolute";
            img.setAttribute("src", url);
            document.body.appendChild(img);

            const redirectUrl = get(
              response,
              "data.data.globalAttributes.redirectUrl.value"
            );

            if (redirectUrl) {
              window.location.href = redirectUrl;
            }
          }
        }
      })
    );
  }
}
